import React from 'react';
import { injectIntl } from 'react-intl';
import ListAsyncMultiple from 'components/layout/subscriptions/ListAsyncMultiple';
import { getNameInCurrentLanguage } from 'helpers/intl';

class ListItems extends React.Component {
  listItemFormatter = item => {
    const { appIntl } = this.props;

    let category =
      item.category && Object.keys(item.category).length > 0
        ? getNameInCurrentLanguage(item.category.name, appIntl) + ' -> '
        : '';

    return category + (typeof item?.name === 'object' ? getNameInCurrentLanguage(item.name, appIntl) : item?.name);
  };

  listItemId = item => {
    return item.id;
  };

  render() {
    const {
      intl: { messages },
      getItems,
      removeData,
      dataInitialValues,
      filter,
    } = this.props;

    let filterData = typeof filter == 'object' ? { filter: filter } : {};

    return (
      <ListAsyncMultiple
        title={messages.items}
        listName="sub_items"
        listUrl="/api/items.json"
        listUrlData={{ depth: 'shallow', ...filterData }}
        listItemFormatter={this.listItemFormatter}
        listItemId={this.listItemId}
        paramName="sub_item"
        getItems={getItems}
        removeData={removeData}
        dataInitialValues={dataInitialValues}
      />
    );
  }
}

export default injectIntl(ListItems);
